export const INCOGNITO_STORAGE_KEY = "incog_mode_cart_cap_storage";
export const INCOGNITO_TOGGLE_LOTTIE_STORAGE_KEY = "incog_mode_cart_toggle_lottie_storage";
